// extracted by mini-css-extract-plugin
module.exports = {"contact":"footer-module--contact--2-4iC","contactTitle":"footer-module--contact-title--2pKND","copyright":"footer-module--copyright--6g7tT"};